var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCliente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 50C4.16667 50 0 50 0 45.8333C0 41.6667 4.16667 29.1667 25 29.1667C45.8333 29.1667 50 41.6667 50 45.8333C50 50 45.8333 50 45.8333 50H4.16667ZM25 25C28.3152 25 31.4946 23.683 33.8388 21.3388C36.183 18.9946 37.5 15.8152 37.5 12.5C37.5 9.18479 36.183 6.00537 33.8388 3.66117C31.4946 1.31696 28.3152 0 25 0C21.6848 0 18.5054 1.31696 16.1612 3.66117C13.817 6.00537 12.5 9.18479 12.5 12.5C12.5 15.8152 13.817 18.9946 16.1612 21.3388C18.5054 23.683 21.6848 25 25 25Z",
    fill: "#EC6726"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCliente);
export default __webpack_public_path__ + "static/media/cliente.77a70d1eba40b07b228430f316473a0d.svg";
export { ForwardRef as ReactComponent };